import { ref } from 'vue'
import { useApi } from '@/functions/api'

export function useCurrencyList () {
  const api = useApi()
  const currencies = ref<Currency[]>([])
  const loading = ref(false)

  const getData = async () => {
    try {
      loading.value = true
      const response = await api.GET<ApiCollection<Currency>>('warehouse/currency')
      currencies.value = response.data
    } finally {
      loading.value = false
    }
  }

  return {
    getData,
    loading,
    currencies,
  }
}
